(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-showcase')) {
    customElements.define(
      'collection-showcase',
      class extends HTMLElement {
        connectedCallback() {
          const track = this.querySelector('[data-track]');
          this.querySelectorAll('[data-direction]').forEach((button) => {
            button.addEventListener('click', () => {
              const slide = track.querySelector('[data-slide]');
              const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
              const step = slide ? slide.offsetWidth + gap : track.clientWidth;
              track.scrollBy({ left: button.dataset.direction === 'right' ? step : -step, behavior: 'smooth' });
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-accordion')) {
    customElements.define(
      'faq-accordion',
      class extends HTMLElement {
        connectedCallback() {
          this.items = [...this.querySelectorAll('[data-faq-item]')];
          this.items.forEach((item) => {
            item.querySelector('[data-faq-button]').addEventListener('click', () => this.toggle(item));
          });
        }

        // opening one question closes the others
        toggle(item) {
          const open = !item.classList.contains('is-open');
          this.items.forEach((other) => {
            const isTarget = other === item && open;
            other.classList.toggle('is-open', isTarget);
            other.querySelector('[data-faq-button]').setAttribute('aria-expanded', String(isTarget));
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticky-add-to-cart')) {
    customElements.define(
      'sticky-add-to-cart',
      class extends HTMLElement {
        connectedCallback() {
          this.mainButton = document.querySelector('product-info [id^="ProductSubmitButton-"]');
          this.button = this.querySelector('[data-sticky-button]');
          this.price = this.querySelector('[data-sticky-price]');
          if (!this.mainButton) return;

          this.button.addEventListener('click', () => this.mainButton.click());

          // shown only while the main button is above the screen
          this.observer = new IntersectionObserver(([entry]) => {
            this.toggle(!entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
          this.observer.observe(this.mainButton);

          // follow the main button (sold out, unavailable) and the main price when the option changes
          this.mutations = new MutationObserver(() => this.sync());
          this.mutations.observe(this.mainButton, { attributes: true, childList: true, subtree: true, characterData: true });
          const mainPrice = document.querySelector('product-info [id^="price-"]');
          if (mainPrice) this.mutations.observe(mainPrice, { childList: true, subtree: true, characterData: true });
          this.sync();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.mutations?.disconnect();
        }

        toggle(visible) {
          this.classList.toggle('is-visible', visible);
          this.inert = !visible;
        }

        sync() {
          const label = this.mainButton.querySelector('span');
          this.button.disabled = this.mainButton.disabled;
          if (label) this.button.textContent = label.textContent.trim();

          const mainPrice = document.querySelector('product-info [id^="price-"] .price');
          if (!mainPrice || !this.price) return;
          const onSale = mainPrice.classList.contains('price--on-sale');
          const current = mainPrice.querySelector(onSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
          if (current) this.price.textContent = current.textContent.trim();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
